module.exports = __webpack_public_path__ + "static/media/oleg.cd933036.jpg";